// Stok tablosunun sütunları. Anahtarlar Stocks dokümanlarındaki alan adlarıdır;
// `id`: stock.columns.<id> (geçerli dilde başlık). Sıra eski tabloyla aynı.
import { OWNERSHIP_TYPES } from '../../utils/stockOwnership';

export const STOCK_COLUMNS = {
  'Adı': { id: 'name', type: 'text', width: 240 },
  'Kategori': { id: 'category', type: 'select', width: 150, options: ['sarf', 'demirbas'] },
  'Bilgi': { id: 'info', type: 'text', width: 200 },
  // Stoklar bir müşteriye/projeye bağlanabilir; demirbaşta kendi firmamız da olabilir
  'customerName': { id: 'customer', type: 'text', width: 180 },
  'projectName': { id: 'project', type: 'text', width: 160 },
  // Yalnızca demirbaş: firma malı, kiralık, müşteriye ait...
  'ownershipType': { id: 'ownership', type: 'select', width: 170, options: OWNERSHIP_TYPES.map((type) => type.value) },
  'Depo': { id: 'warehouse', type: 'text', width: 140 },
  'Durum': { id: 'status', type: 'select', width: 120, options: ['aktif', 'inaktif'] },
  'Döviz Kuru': { id: 'rate', type: 'text', width: 120 },
  'Döviz Tipi': { id: 'currency', type: 'select', width: 120, options: ['TRY', 'USD', 'EUR'] },
  'Giriş Fiyatı': { id: 'purchasePrice', type: 'text', width: 130 },
  'Kalan': { id: 'remaining', type: 'text', width: 120 },
  'Min Miktar': { id: 'minQuantity', type: 'text', width: 120 },
  'Kar Oranı(%)': { id: 'profitRate', type: 'text', width: 130 },
  'Kullanma Başlama Tarihi': { id: 'startDate', type: 'date', width: 180 },
  'Miktar': { id: 'quantity', type: 'text', width: 110 },
  'Son Kullanma Tarihi': { id: 'expiryDate', type: 'date', width: 170 },
  'Stok Tipi': { id: 'stockType', type: 'text', width: 170 },
  'Yıpranma Payı': { id: 'depreciation', type: 'text', width: 140 },
  'Çıkış Fiyatı': { id: 'salePrice', type: 'text', width: 130 },
};

export const COLUMN_KEYS = Object.keys(STOCK_COLUMNS);

// İlk açılışta görünen sütunlar (eski tablonun varsayılanları)
export const DEFAULT_VISIBLE_COLUMNS = {
  'Adı': true,
  'Kategori': true,
  'Bilgi': true,
  'customerName': true,
  'projectName': true,
  'ownershipType': true,
  'Depo': true,
  'Durum': true,
  'Döviz Kuru': false,
  'Döviz Tipi': true,
  'Giriş Fiyatı': true,
  'Kalan': true,
  'Min Miktar': true,
  'Kar Oranı(%)': false,
  'Kullanma Başlama Tarihi': true,
  'Miktar': true,
  'Son Kullanma Tarihi': true,
  'Stok Tipi': true,
  'Yıpranma Payı': false,
  'Çıkış Fiyatı': true,
};

export const MIN_COLUMN_WIDTH = 96;
export const PINNED_COLUMNS = ['Adı'];

const EMPTY_MARKERS = ['nan', 'nat', 'n/a', 'null', 'undefined'];

/** Eski tablodaki gibi: boş, NaN ve "null" benzeri değerler boş sayılır. */
export const isEmptyValue = (value) =>
  value === null ||
  value === undefined ||
  value === '' ||
  Number.isNaN(value) ||
  (typeof value === 'string' && EMPTY_MARKERS.includes(value.trim().toLowerCase()));

/** Filtreler yazıldığı anda uygulanır (useStockManagement'teki süzme ile aynı). */
export const getFilterState = (key, value) => (value === undefined || value === null || String(value) === '' ? 'off' : 'applied');
